import { IonCard, IonCardContent } from '@ionic/react';
import SlideContent from '../../../components/slide-content/SlideContent';

import HR from '../../../layouts/HR';
import AvatarImage from './Section1/AvatarImage';
import NationalCardImage from './Section1/NationalCardImage';

interface Props {
    formProvider: any,
    defaultProfile: any,
    defaultNationalCard: any
}

const Section1: React.FC<Props> = (props) => {
    return <SlideContent type="navbar" class="section1">
        <IonCard>
            <IonCardContent>
                <AvatarImage form={props.formProvider.form} setForm={props.formProvider.setForm} defaultImage={props.defaultProfile} />

                <HR className="ion-margin-bottom" />

                <NationalCardImage form={props.formProvider.form} setForm={props.formProvider.setForm} defaultImage={props.defaultNationalCard} />
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Section1